import { ProxyServerType } from "@fd/common/biz/proxyType";

export const singleProxyToString = (proxy: ProxyServerType) => {
  return `http://${proxy.username}:${proxy.password}@${proxy.host}:${proxy.port}`;
};
